import React from 'react';
import FastMarquee from 'react-fast-marquee';

const Marquee = ({ children, ...otherProps }) => (
  <FastMarquee {...otherProps}>
    <div className="marquee-content" style={{ paddingRight: 30 }}>
      {children}
    </div>
  </FastMarquee>
);

export default Marquee;
